// import SideNavbaBarDashboard from "../SideNavaBarDashboard/SideNavbaBarDashboard"
// import axios from 'axios';
// const AccountDetails = () => {
//     const fetchAccountDetails = async (token) => {
//         try {
//           const response = await axios.get('/api/account-details', {
//             headers: { Authorization: `Bearer ${token}` },
//           });
//           return response.data; // Contains firstname, lastname, email
//         } catch (error) {
//           console.error('Error fetching account details:', error);
//           return null;
//         }
//       };
//     return(
//         <>
//         <div className="tf-page-title">
//             <div className="container-full">
//                 <div className="heading text-center">Account Details</div>
//             </div>
//         </div>
//         <section className="flat-spacing-11">
//             <div className="container">
//                 <div className="row">
//                     <SideNavbaBarDashboard/>
//                     <div className="col-lg-9">
//                         <div className="my-account-content account-edit">
//                             <div className="">
//                                 <form className="" id="form-password-change" action="#">
//                                     <div className="tf-field style-1 mb_15">
//                                         <input className="tf-field-input tf-input" placeholder=" " type="text" id="property1" name="first name"/>
//                                         <label className="tf-field-label fw-4 text_black-2" for="property1">First name</label>
//                                     </div>
//                                     <div className="tf-field style-1 mb_15">
//                                         <input className="tf-field-input tf-input" placeholder=" " type="text" id="property2" name="last name"/>
//                                         <label className="tf-field-label fw-4 text_black-2" for="property2">Last name</label>
//                                     </div>
//                                     <div className="tf-field style-1 mb_15">
//                                         <input className="tf-field-input tf-input" placeholder=" " type="email" id="property3" name="email"/>
//                                         <label className="tf-field-label fw-4 text_black-2" for="property3">Email</label>
//                                     </div>
//                                     <h6 className="mb_20">Password Change</h6>
//                                     <div className="tf-field style-1 mb_30">
//                                         <input className="tf-field-input tf-input" placeholder=" " type="password" id="property4" name="password"/>
//                                         <label className="tf-field-label fw-4 text_black-2" for="property4">Current password</label>
//                                     </div>
//                                     <div className="tf-field style-1 mb_30">
//                                         <input className="tf-field-input tf-input" placeholder=" " type="password" id="property5" name="password"/>
//                                         <label className="tf-field-label fw-4 text_black-2" for="property5">New password</label>
//                                     </div>
//                                     <div className="tf-field style-1 mb_30">
//                                         <input className="tf-field-input tf-input" placeholder=" " type="password" id="property6" name="password"/>
//                                         <label className="tf-field-label fw-4 text_black-2" for="property6">Confirm password</label>
//                                     </div>
//                                     <div className="mb_20">
//                                         <button type="submit" className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center">Save Changes</button>
//                                     </div>
//                                 </form>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </section>

//         <div className="btn-sidebar-account">
//             <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas"><i className="icon icon-sidebar-2"></i></button>
//         </div>

//         <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
//         <div className="canvas-wrapper">
//             <header className="canvas-header">
//                 <span className="title">SIDEBAR ACCOUNT</span>
//                 <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
//             </header>
//             <div className="canvas-body sidebar-mobile-append"> </div>
//         </div>       
//     </div>
//         </>
//     )
// }
// export default AccountDetails




import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { AiOutlineDoubleRight } from "react-icons/ai";
import SideNavbaBarDashboard from "../SideNavaBarDashboard/SideNavbaBarDashboard";
import { CiMenuBurger } from "react-icons/ci";
const AccountDetails = () => {
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    // currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const token = localStorage.getItem("token"); // Assuming the token is stored in localStorage

  useEffect(() => {
    const fetchAccountDetails = async () => {
      try {
        setLoading(true);
        const response = await axios.get("/api/account-details", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        const { firstname, lastname, email } = response.data;
        setFormData((prev) => ({
          ...prev,
          firstname,
          lastname,
          email,
        }));
      } catch (err) {
        // setError("Failed to load account details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    if (token) {
      fetchAccountDetails();
    } else {
      setError("User is not authenticated. Please log in.");
      setLoading(false);
    }
  }, [token]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Add backend integration to save changes
      const response = await axios.post(`/api/update-account-details`,
        {
          firstname: formData.firstname,
          lastname: formData.lastname,
          email: formData.email,
          // currentPassword: formData.currentPassword,
          newPassword: formData.newPassword,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      if (response.status === 200) {
        alert("Account details updated successfully.");
      }
      if (response.status === 201) {
        alert("Account details Added successfully.");
      }
    } catch (err) {
      alert("Failed to update account details. Please try again.");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }



  return (
    <>
      <div class="tf-page-title">
        <div class="row">
          <div class="col-12">
            <div class="heading text-center ">
              <h4 className='breadcrumbtitle'>Account Details</h4>
              <div className=' breadcrumb'>
                <Link to="/" style={{ color: "black" }} ><h6>Home</h6></Link><AiOutlineDoubleRight size={20} style={{ marginTop: "0.5vh" }} />
                <h6>Account Details</h6></div>
            </div>
          </div>
        </div>

      </div>
      <section className="flat-spacing-11">
        <div className="container">
          <div className="row">
            <SideNavbaBarDashboard />
            <div className="col-lg-9">
              <div className="error-message">{error}</div>
              <div className="my-account-content account-edit">
                <form
                  className=""
                  id="form-password-change"
                  onSubmit={handleSubmit}
                >
                  <div className="tf-field style-1 mb_15">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="text"
                      id="firstname"
                      name="firstname"
                      value={formData.firstname}
                      onChange={handleChange}
                    />
                    <label
                      className="tf-field-label fw-4 text_black-2"
                      htmlFor="firstname"
                    >
                      First name
                    </label>
                  </div>
                  <div className="tf-field style-1 mb_15">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="text"
                      id="lastname"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                    />
                    <label
                      className="tf-field-label fw-4 text_black-2"
                      htmlFor="lastname"
                    >
                      Last name
                    </label>
                  </div>
                  <div className="tf-field style-1 mb_15">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                    <label
                      className="tf-field-label fw-4 text_black-2"
                      htmlFor="email"
                    >
                      Email
                    </label>
                  </div>
                  <h6 className="mb_20">Password Change</h6>
                  {/* <div className="tf-field style-1 mb_30">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="password"
                      id="currentPassword"
                      name="currentPassword"
                      value={formData.currentPassword}
                      onChange={handleChange}
                    />
                    <label
                      className="tf-field-label fw-4 text_black-2"
                      htmlFor="currentPassword"
                    >
                      Current password
                    </label>
                  </div> */}
                  <div className="tf-field style-1 mb_30">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="password"
                      id="newPassword"
                      name="newPassword"
                      value={formData.newPassword}
                      onChange={handleChange}
                    />
                    <label
                      className="tf-field-label fw-4 text_black-2"
                      htmlFor="newPassword"
                    >
                      New password
                    </label>
                  </div>
                  <div className="tf-field style-1 mb_30">
                    <input
                      className="tf-field-input tf-input"
                      placeholder=" "
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      value={formData.confirmPassword}
                      onChange={handleChange}
                    />
                    <label
                      className="tf-field-label fw-4 text_black-2"
                      htmlFor="confirmPassword"
                    >
                      Confirm password
                    </label>
                  </div>
                  <div className="mb_20">
                    <button
                      type="submit"
                      className="tf-btn w-100 radius-3 btn-fill animate-hover-btn justify-content-center"
                    >
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <div className="btn-sidebar-account">
        <button data-bs-toggle="offcanvas" data-bs-target="#mbAccount" aria-controls="offcanvas">
          <CiMenuBurger />
        </button>
      </div>

      <div className="offcanvas offcanvas-start canvas-filter canvas-sidebar canvas-sidebar-account" id="mbAccount">
        <div className="canvas-wrapper">
          <header className="canvas-header">
            <span className="title">SIDEBAR ACCOUNT</span>
            <SideNavbaBarDashboard />
            <span className="icon-close icon-close-popup" data-bs-dismiss="offcanvas" aria-label="Close"></span>
          </header>
          <div className="canvas-body sidebar-mobile-append"> </div>
        </div>
      </div>
    </>
  );
};

export default AccountDetails;
